/*
 * © 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksTemplate/TriPeaksCardAnimator',[
        'lodash',
        'pixi',
        'absolute/debug',
        'util/dictionary',
        'Arkadium/GameEngine/Maths/Vector2',
        'Arkadium/GameEngine/Maths/Bezier2D',
        'Arkadium/GameEngine/Core/EngineManagers',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Tween/Tween',
        'SolitaireShared/CardLogic/CardOp',
        'SolitaireShared/CardLogic/CardValue',
        'CardUI/PileView',
        'CardUI/CardView',
        'absolute/particleemitter',
        'absolute/coords',
        'absolute/stringmanager',
        'absolute'
    ],
    function (_, PIXI, Debug, Dictionary, Vector2, Bezier2D, EngineManagers, SpriteNode,
              Tween, CardOp, CardValue, PileView, CardView, ParticleEmitter, Coords, _s, Absolute) {
        "use strict";

        var TriPeaksCardAnimator = function (supplyView) {
            this.initTriPeaksCardAnimator(supplyView);
        };

        TriPeaksCardAnimator.prototype.initTriPeaksCardAnimator = function (supplyView) {
            this.SupplyView = supplyView;
            this.AnimationList = new Dictionary(SpriteNode, Array);
            this.TweenCache = new Dictionary(SpriteNode, Tween);

            this.IsInAnimationSet = false;
            this.DealCardNum = 0;
            this.IsDeal = false;
            this.IsUndoing = false;

            this.AnimatingAction = null;
            this.IsShuffling = false;
            this.NextAnimationDelay = 0;
            this.nextAnimationAction = null;

            this.AnimationDelayTimer = 0;

            this.SupplyView.CardSupply.Authority.onBonusEffectEventHanlder.add(this.bonusEffect.bind(this));

            this.emitters = [];
            this.cleanUpTimeout = null;

            // TODO this.WinAnimator = new ButterflyWinAnimator(this.SupplyView);
            this.WinAnimator = null;
        };

        var ROTATION_ANGLE = Math.PI;
        var ANIMATION_LENGTH = 0.1;
        var ANIMATION_DELAY = 0.1;
        var CARD_DELAY = 0.05;

        var ANIM_LENGTH_DRAW = 0.2;
        var CARD_DELAY_DRAW = 0.1;

        // ParticleEffectNode PeakEffect;

        TriPeaksCardAnimator.AnimationEntry = function (pos, rot, scale, cardFlip, wait, speed, sound, onComplete) {
            this.initAnimationEntry(pos, rot, scale, cardFlip, wait, speed, sound, onComplete);
        };

        TriPeaksCardAnimator.AnimationEntry.prototype.initAnimationEntry = function (pos, rot, scale, cardFlip, wait, speed, sound, onComplete) {
            this.WorldPos = pos ? pos.clone() : new PIXI.Point(0, 0);
            this.WorldRot = rot;
            this.WorldScale = scale ? scale.clone() : new PIXI.Point(1, 1);
            this.CardFlip = cardFlip || 0;
            this.Wait = wait || 0;
            this.Speed = speed || 0;
            this.ForceLayer = null;
            this.ForceLayer2 = null;
            this.SoundToPlayAtFinish = sound;
            this.OnComplete = onComplete;
        };

        TriPeaksCardAnimator.prototype.bonusEffect = function (authority, data) {

            if (this.cleanUpTimeout !== null) {
                window.clearTimeout(this.cleanUpTimeout);
                this.cleanUpTimeout = null;
            }

            if (!this.particleLayer) {
                this.particleLayer = new PIXI.DisplayObjectContainer();
            }

            this.SupplyView.CardSupply.IncrementActiveAnimations();

            var bonusImage = PIXI.Sprite.fromFrame(data.bonus.toString() + '.png'),
                bonusBackground = PIXI.Sprite.fromFrame('tripeaks_cardburst.png'),
                bonusGodRays = PIXI.Sprite.fromFrame('tripeaks_cardburst_godrays.png'),
                bonusBounce, bonusFade, bonusBackgroundTween, bonusGodRayTween,
                emitterOptions = {
                    rate: {
                        numpan: {a: .3 * data.bonus, b: .6 * data.bonus, center: null},
                        timepan: {a: 0.1, b: 0.2, center: null}
                    },
                    mass: 1,
                    rotation: {a: [5, 10, 15, 20, 25, 30, 35, 40, 45], b: [0, 3], style: 'add'},
                    velocity: {rpan: {a: 0, b: 4, center: null}, thapan: {a: 0, b: 360, center: null}, type: 'polar'},
                    alpha: {a: 1, b: 0},
                    scale: {a: [0.25, 0.02], b: 0, center: null},
                    gravity: 0,
                    life: {a: 0.5, b: 1, center: null},
                    radius: 1,
                    crossZone: null,
                    randomDrift: null
                },
                textures = [PIXI.Texture.fromFrame('Star.png'), PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png')],
                emitter = new ParticleEmitter(EngineManagers.UI, textures, emitterOptions),
                pileView = this.SupplyView.GetPileView(data.pile),
                effectPosition = {
                    'x': pileView.worldTransform.tx,
                    'y': pileView.worldTransform.ty
                },
                soundToPlay = 'peak' + data.peaks,
                self = this;

            this.emitters.push(emitter);

            emitter.x = effectPosition.x;
            emitter.y = effectPosition.y;

            bonusImage.x = bonusGodRays.x = bonusBackground.x = effectPosition.x;
            bonusImage.y = bonusGodRays.y = bonusBackground.y = effectPosition.y;
            bonusImage.anchor.x = bonusImage.anchor.y = bonusGodRays.anchor.x = bonusGodRays.anchor.y = bonusBackground.anchor.x = bonusBackground.anchor.y = 0.5;
            bonusImage.scale.x = bonusImage.scale.y = 0;

            this.particleLayer.addChild(emitter);
            this.particleLayer.addChild(bonusGodRays);
            this.particleLayer.addChild(bonusBackground);
            this.particleLayer.addChild(bonusImage);

            EngineManagers.UI.stage[0].addChild(this.particleLayer);

            EngineManagers.Sounds.PlaySound(soundToPlay);

            let endX = 1;
            let endY = 1;
            const canvasContainer = EngineManagers.UI.container.children[0];
            if (!!canvasContainer) {
                const ratio = canvasContainer.offsetWidth / canvasContainer.offsetHeight;
                if (ratio > 1) {
                    endX = 1 / ratio;
                } else {
                    endY = ratio;
                }
            }

            bonusBackgroundTween = new TWEEN.Tween({scale: 2, alpha: 1})
                .easing(TWEEN.Easing.Exponential.Out)
                .to({scale: 0, alpha: 0}, 1400)
                .onUpdate(function () {
                    bonusBackground.scale.x = bonusBackground.scale.y = this.scale;
                    bonusBackground.alpha = this.alpha;
                }).start();

            bonusGodRayTween = new TWEEN.Tween({scale: data.peaks * 0.5, alpha: 1, rotation: bonusGodRays.rotation})
                .easing(TWEEN.Easing.Linear.None)
                .to({scale: 0, alpha: 0, rotation: 3}, 1000)
                .onUpdate(function () {
                    bonusGodRays.scale.x = bonusGodRays.scale.y = this.scale;
                    bonusGodRays.alpha = this.alpha;
                    bonusGodRays.rotation = this.rotation;
                }).start();

            bonusBounce = new TWEEN.Tween({scaleX: 0, scaleY: 0, alpha: 0})
                .easing(TWEEN.Easing.Exponential.Out)
                .delay(300)
                .onStart(function () {
                    emitter.emitOnce();
                })
                .to({scaleX: endX, scaleY: endY, alpha: 1}, 400)
                .onUpdate(function () {
                    bonusImage.scale.x = this.scaleX;
                    bonusImage.scale.y = this.scaleY;
                    bonusImage.alpha = this.alpha;
                }).start();

            bonusFade = new TWEEN.Tween({alpha: 1})
                .easing(TWEEN.Easing.Cubic.Out)
                .delay(1000)
                .to({alpha: 0}, 500)
                .onUpdate(function () {
                    bonusImage.alpha = this.alpha;
                })
                .onComplete(function () {
                    if (!data.isPerfect) {
                        self.SupplyView.CardSupply.DecrementActiveAnimations();
                    }
                    self.cleanUpTimeout = window.setTimeout(function () {
                        if (!data.isPerfect) {
                            self.cleanUpParticles();
                        }
                    }, 5000);
                });

            bonusBounce.chain(bonusFade);

            // if the board is cleared
            if (data.isPerfect) {

                var perfectText = this.createTextureForPerfectText(),
                    perfectFadeIn, perfectFadeout, godTween;

                perfectText.anchor.x = 0.5;
                perfectText.anchor.y = 0.5;
                perfectText.alpha = 0;
                perfectText.x = EngineManagers.UI.width / 2;
                perfectText.y = EngineManagers.UI.height / 2;

                this.particleLayer.addChild(perfectText);
                //EngineManagers.UI.stage[0].addChild(perfectText);

                godTween = new TWEEN.Tween({scale: 2, alpha: 1, rotation: bonusGodRays.rotation})
                    .easing(TWEEN.Easing.Linear.None)
                    .delay(600)
                    .to({scale: 0, alpha: 0, rotation: 3}, 1000)
                    .onStart(function () {
                        bonusGodRays.x = perfectText.x;
                        bonusGodRays.y = perfectText.y;
                        bonusGodRays.rotation = 0;
                    })
                    .onUpdate(function () {
                        bonusGodRays.scale.x = bonusGodRays.scale.y = this.scale;
                        bonusGodRays.alpha = this.alpha;
                        bonusGodRays.rotation = this.rotation;
                    }).start();

                perfectFadeIn = new TWEEN.Tween({scaleX: 0, scaleY: 0, alpha: 0})
                    .easing(TWEEN.Easing.Exponential.Out)
                    .delay(600)
                    .to({scaleX: endX, scaleY: endY, alpha: 1}, 400)
                    .onStart(function () {
                        EngineManagers.Sounds.PlaySound('perfect');
                    })
                    .onUpdate(function () {
                        perfectText.scale.x = this.scaleX;
                        perfectText.scale.y = this.scaleY;
                        perfectText.alpha = this.alpha;
                    }).start();

                perfectFadeout = new TWEEN.Tween({alpha: 1, y: perfectText.y})
                    .easing(TWEEN.Easing.Cubic.Out)
                    .delay(1000)
                    .to({alpha: 0, y: Coords.y(100)}, 2500)
                    .onUpdate(function () {
                        perfectText.alpha = this.alpha;
                        perfectText.y = this.y;
                    })
                    .onComplete(function () {
                        self.SupplyView.CardSupply.DecrementActiveAnimations();
                        self.cleanUpTimeout = window.setTimeout(function () {
                            self.cleanUpParticles();
                        }, 5000);
                    });

                perfectFadeIn.chain(perfectFadeout);

            }
        };

        TriPeaksCardAnimator.prototype.trimCanvas = function (canvas, context) {
            var copy = document.createElement('canvas').getContext('2d'),
                pixels = context.getImageData(0, 0, canvas.width, canvas.height),
                bound = {
                    top: null,
                    left: null,
                    right: null,
                    bottom: null
                };
            this.findTransparentPixels(bound, pixels, canvas);
            return this.getTrimmedCanvas(bound, copy, context);
        };

        TriPeaksCardAnimator.prototype.findTransparentPixels = function (bound, pixels, canvas) {
            var x, y;
            var pixelsCount = pixels.data.length;
            for (var i = 0; i < pixelsCount; i += 4) {
                if (pixels.data[i + 3] !== 0) {
                    x = (i / 4) % canvas.width;
                    y = ~~((i / 4) / canvas.width);
                    this.checkBounds(bound, x, y);
                }
            }
        };

        TriPeaksCardAnimator.prototype.getTrimmedCanvas = function(bound, context, prevContext) {
            var trimHeight = bound.bottom - bound.top,
                trimWidth = bound.right - bound.left,
                trimmed = prevContext.getImageData(bound.left, bound.top, trimWidth, trimHeight);
            context.canvas.width = trimWidth;
            context.canvas.height = trimHeight;
            context.putImageData(trimmed, 0, 0);
            return context.canvas;
        };

        TriPeaksCardAnimator.prototype.checkBounds = function (bound, x, y) {
            if (!bound.top) bound.top = y;
            if (!bound.left) bound.left = x;
            else if (x < bound.left) bound.left = x;
            if (!bound.right) bound.right = x;
            else if (bound.right < x) bound.right = x;
            if (!bound.bottom) bound.bottom = y;
            else if (bound.bottom < y) bound.bottom = y;
        };

        TriPeaksCardAnimator.prototype.BeginAnimationSet = function (numActionsToExpect) {
            this.IsInAnimationSet = true;
            this.AnimationDelayTimer = 0;
            this.AnimationList.Clear();
            this.DealCardNum = 0;
            this.IsDeal = false;
        };

        TriPeaksCardAnimator.prototype.EndAnimationSet = function () {
            this.IsInAnimationSet = false;
        };

        TriPeaksCardAnimator.prototype.BeginAnimation = function (action, isUndoing) {
            if (!this.IsInAnimationSet) {
                this.AnimationDelayTimer = 0;
                this.AnimationList.Clear();
                this.DealCardNum = 0;
                this.IsDeal = false;
            }

            this.AnimatingAction = action;
            this.IsUndoing = isUndoing;
            // save the starting position for each card
            _.forEach(this.SupplyView.CardSupply.GetCardList(), function (card) {
                var cardView = this.SupplyView.GetCardView(card);
                if (!this.AnimationList.ContainsKey(cardView)) {
                    // create the animation list entry
                    var current = new TriPeaksCardAnimator.AnimationEntry();
                    current.Wait = this.AnimationDelayTimer; // starting location
                    current.Speed = 0;
                    //cardView.SceneTransform.Decompose(out current.WorldScale, out current.WorldRot, out current.WorldPos);
                    if (cardView.parent)
                        current.WorldPos = cardView.parent.toGlobal(cardView.position);
                    // TODO scale, rot

                    this.AnimationList.Add(cardView, [current]);
                }
            }, this);
        };

        TriPeaksCardAnimator.prototype.ContinueAnimation = function (action, opNum) {
            this.SupplyView.UpdatePileChildren(false);

            var AnimSpeed = ANIMATION_LENGTH;
            var AnimDelay = ANIMATION_DELAY;
            var CardDelaySpeed = CARD_DELAY;
            var op = action.Ops[opNum];

            // dealing
            if (!this.SupplyView.CardSupply.EnforceGameRules) {
                AnimSpeed = 0.2;
                AnimDelay = 0.1;
                CardDelaySpeed = 0;
            }
            if (action.Ops.length > 24) {
                AnimDelay *= 0.4; // deal
                CardDelaySpeed *= 0.4;
            }


            if (op.Opcode == CardOp.Op.Move) {
                var fromPile = op.GetPile(CardOp.eMoveParams.SourcePile);
                var toPile = op.GetPile(CardOp.eMoveParams.DestPile);
                var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);
                var movePileToBottom = false;

                if (fromPile.Type == "Stock") {
                    AnimSpeed = ANIM_LENGTH_DRAW;
                    CardDelaySpeed = CARD_DELAY_DRAW;
                }

                if (fromPile.Type == "Stock" && (toPile.Type == "Tableau" || toPile.Type == "FaceDown")) {
                    movePileToBottom = true;
                }

                if (this.IsUndoing) {
                    // if undoing, swap the piles
                    var tmp = fromPile;
                    fromPile = toPile;
                    toPile = tmp;

                    CardDelaySpeed *= 0.75;
                    AnimDelay *= 0.75;
                    AnimSpeed *= 0.75;
                }

                var fromPileView = this.SupplyView.GetPileView(fromPile);
                var toPileView = this.SupplyView.GetPileView(toPile);
                var rev = false;
                if (numCards < 0) {
                    numCards = -numCards;
                    rev = true;
                }

                if (numCards > 12) {
                    this.IsDeal = true;
                    CardDelaySpeed *= 0.1;
                    this.SupplyView.reversePiles(); // this is so the piles look visually correct when the deal happens
                } else if (numCards > 6) {
                    CardDelaySpeed *= 0.25;
                }

                if (fromPileView.CardFacing == PileView.Facing.Hidden ||
                    toPileView.CardFacing == PileView.Facing.Hidden) {
                    AnimSpeed = 0;
                    AnimDelay = 0;
                    CardDelaySpeed = 0;
                } else {
                    if (this.NextAnimationDelay > 0) {
                        this.AnimationDelayTimer += this.NextAnimationDelay;
                        this.NextAnimationDelay = 0;
                    }
                }
                for (var cardNum = 0; cardNum < numCards; cardNum++) {
                    var cardIdx = cardNum + 1;
                    if (rev)
                        cardIdx = numCards - cardNum;

                    var card = toPile.NthFromTop(cardIdx);
                    var cardView = this.SupplyView.GetCardView(card);

                    // var first = this.AnimationList.Get(cardView)[0];  TODO not used?

                    var next = new TriPeaksCardAnimator.AnimationEntry();
                    next.Wait = this.AnimationDelayTimer;
                    next.Speed = AnimSpeed;
                    //cardView.SceneTransform.Decompose(out next.WorldScale, out next.WorldRot, out next.WorldPos);
                    //Vector2 cardPos = cardView.GetCardPositionInPile(null, true);
                    //next.WorldPos = cardView.Parent.ToGlobal(new Vector3(cardPos.X, cardPos.Y, cardView.Z));

                    if (movePileToBottom) {
                        next.OnComplete = function () {
                            this.SupplyView.pileViewToIndex(toPileView);
                        }.bind(this);
                    }

                    var cardPos = cardView.GetCardPositionInPile(null, true);
                    next.WorldPos = cardView.Parent.toGlobal(cardPos); // TODO z order?

                    if (toPileView.CardFacing == PileView.Facing.FaceDown) {
                        next.CardFlip = 1;
                    } else {
                        next.CardFlip = 0;
                    }

                    // DEAL ANIMATION:
                    // Display cards dealt from top of deck in pile ordering (see TriPeaksAuthority for numbering).
                    if (this.IsDeal && numCards == 1) {
                        next.ForceLayer = CardView.TopLayer + 1 + card.Supply.Count - this.DealCardNum;
                        next.ForceLayer2 = CardView.TopLayer + 1 + card.Supply.Count + this.DealCardNum;

                        this.DealCardNum++;
                    }/*
                 if (fromPile.Type == "Stock" && (toPile.Type == "Tableau" || toPile.Type == "FaceDown"))
                 {
                 int pileNum = int.Parse(toPile.Name.Substring(toPile.Type.Length));
                 next.ForceLayer = CardView.TOP_LAYER + 27 - pileNum;
                 }*/
                    else if (this.SupplyView.GetPileView(fromPile).CardFacing == PileView.Facing.FaceDown && this.SupplyView.GetPileView(toPile).CardFacing == PileView.Facing.FaceUp) {
                        next.SoundToPlayAtFinish = "flipCard";
                    }

                    if (fromPile.Type == "Tableau" && toPile.Type == "Waste") {


                        // Tableau to waste spinny animation.
                        var delta = fromPileView.toLocal(toPileView.toGlobal(new PIXI.Point(0, 0)));
                        var offset = 0.03 * cardView.Height;

                        var p1 = Vector2.Zero;
                        var p2 = new Vector2(delta.x, -0.4 * EngineManagers.Display.Height);
                        var p3 = new Vector2(p2.x, delta.y + offset);

                        var bezier = new Bezier2D([p1, p2, p3], Bezier2D.BezierPointType.Control);
                        next.Bezier = bezier;

                        var pileNum = parseInt(fromPile.Name.substring("Tableau".length));
                        if (pileNum <= 2) // If this is a peak, don't call the end animation callback until the bonus animation finishes.
                            next.WaitAfter = 1;

                        next.ForceLayer = CardView.TopLayer + 1;

                        //next.SoundToPlayAtFinish = "matchCard";
                        //this.SupplyView.CardSupply.Authority.GetScoreForAction(action);

                        //var ct = Math.min((action.Tag & 0xFFFF) >>> 0, 16);

                        var tag = (action.Tag | this.SupplyView.CardSupply.Authority._chainNumber) >>> 0,
                            ct = Math.min((tag & 0xFFFF) >>> 0, 15);
                        var cardd = toPile.NthFromTop(2);
                        if (cardd.Value == CardValue.Values.Joker) {
                            next.SoundToPlayAtFinish = "cardOnWildCard";
                        } else {
                            if (ct > 15) {
                                next.SoundToPlayAtFinish = 'matchCard16';
                            } else {
                                next.SoundToPlayAtFinish = 'matchCard' + (ct + 1);
                            }
                        }

                    }

                    this.AnimationList.Get(cardView).push(next);

                    if (numCards > 1)
                        this.AnimationDelayTimer += CardDelaySpeed;
                }

                this.AnimationDelayTimer += AnimDelay;
            }
        };

        TriPeaksCardAnimator.prototype.EndAnimation = function (action, callThisWhenFinished) {
            var tweensToFinish = 0;
            this.TweenCache.Clear();

            // now, actually perform all the tweens that we set up earlier
            _.forEach(this.AnimationList.GetKeys(), function (node) {
                var tweenList = this.AnimationList.Get(node);
                if (tweenList.length < 2)
                    return; // no anim for this node

                if (node instanceof CardView)
                    node.Animating = true;

                tweensToFinish++;

                var tween;
                if (this.TweenCache.ContainsKey(node)) {
                    tween = TweenCache.Get(node).Then();
                } else {
                    var tweens = Tween.GetTweens(node);
                    if (tweens != null && tweens.length > 0)
                        tween = tweens[0].Then();
                    else
                        tween = Tween.Start(node);
                    // TODO tween.Completed += (t, n) => TweenCache.Remove(n.Data as SceneNode);
                    this.TweenCache.Add(node, tween);
                }

                for (var i = 0; i < tweenList.length; i++) {
                    var tweenEntry = tweenList[i];

                    // First, take all of the world transform stuff and take it back to the node's local space.
                    // Vector3 pos = Vector3.TransformCoordinate(tweenEntry.WorldPos, node.Parent.InverseSceneTransform);
                    // Vector3 scale = Vector3.TransformNormal(tweenEntry.WorldScale, node.Parent.InverseSceneTransform);

                    var pos = node.parent.toLocal(tweenEntry.WorldPos);
                    var scale = node.scale.clone();


                    // Set the forced card layer before we start tweening.
                    if (tweenEntry.ForceLayer != null && node instanceof CardView) {
                        node.LayerWhileAnimating = tweenEntry.ForceLayer.Value;
                    }

                    if (i == 0) {
                        node.SetPosition(pos);
                        node.SetScale(scale);
                    } else {
                        tween = tween.Wait(tweenEntry.Wait).Then();
                        if (tweenEntry.Wait > 0 && this.nextAnimationAction != null) {
                            var callAnimation = this.nextAnimationAction;
                            tween = tween.Call(callAnimation).And();
                            this.nextAnimationAction = null;
                        }

                        if (tweenEntry.OnComplete != null) {
                            tween.Call(function () {
                                window.setTimeout(function () {
                                    tweenEntry.OnComplete();
                                }, 100);
                            });
                        }

                        if (tweenEntry.Bezier == null) {
                            tween = tween.MoveTo(pos, tweenEntry.Speed, tweenEntry.Easing);
                        } else {
                            // Hard-coded match animation logic.

                            tween = tween.MoveByBezier(tweenEntry.Bezier, 0.6)
                                .And().RotateBy(ROTATION_ANGLE * 4, 0.5)
                                .Then()
                                .MoveTo(pos, 0.1);

                        }

                        tween = tween.And().ScaleTo(scale, tweenEntry.Speed, tweenEntry.Easing);

                        if (node instanceof CardView) {
                            tween = tween.And().CustomTo(
                                node.SetCardFlipAngle.bind(node),
                                node.GetCardFlipAngle.bind(node),
                                tweenEntry.CardFlip,
                                tweenEntry.Speed,
                                TWEEN.Easing.Exponential.Out);
                        }
                    }

                    tween = tween.Then();

                    // Unset the forced card layer once the tween finishes.
                    if ((tweenEntry.ForceLayer != null || tweenEntry.ForceLayer2 != null) && node instanceof CardView) {
                        tween = tween.Call(function (n) {
                            if (n instanceof CardView)
                                n.LayerWhileAnimating = null;
                        });
                    }

                    if (tweenEntry.SoundToPlayAtFinish != null) {
                        // SAM OVER HERE OVER HERE!!!
                        tween.Call(function () {
                            EngineManagers.Sounds.PlaySound(tweenEntry.SoundToPlayAtFinish);
                        });
                    }

                }
                tween = tween.Call(this.StopAnimating.bind(this));
                tween = tween.Call(
                    function () {
                        tweensToFinish = this.EndAnimTrigger(tweensToFinish, callThisWhenFinished);
                    }.bind(this));
            }, this);
            this.AnimationList.Clear();
            this.TweenCache.Clear();

            //lock (AnimationLock)
            //{
            if (tweensToFinish == 0) {
                if (callThisWhenFinished != null)
                    callThisWhenFinished(action);
            }
            //}
        };

        TriPeaksCardAnimator.prototype.GetTweenedTimeScale = function (node, prop, timeScale) {
            timeScale = EngineManagers.TimeScale;
            return timeScale; // TODO where called/
        };

        TriPeaksCardAnimator.prototype.SetTweenedTimeScale = function (node, prop, timeScale) {
            EngineManagers.TimeScale = timeScale;
        };

        TriPeaksCardAnimator.prototype.StopAnimating = function (node) {
            if (node instanceof CardView)
                node.Animating = false;
        };

        // TODO public event ShuffleFinishedDelegate OnShuffleFinished;
        TriPeaksCardAnimator.prototype.EndAnimTrigger = function (/* TODO ref int */ tweensToFinish, /*ref AnimationCompletionDelegate */ onComplete) {
            //lock (AnimationLock)
            //{
            tweensToFinish--;
            if (tweensToFinish == 0) {
                if (this.IsShuffling) {
                    this.IsShuffling = false;
                    if (this.OnShuffleFinished != null)
                        this.OnShuffleFinished();

                    this.SupplyView.undoReversePiles();
                }
                if (onComplete != null) {
                    onComplete(this.AnimatingAction);
                    onComplete = null; // one-time only
                }
            }
            //}
            return tweensToFinish;
        };

        TriPeaksCardAnimator.prototype.createTextureForPerfectText = function () {
            var canvas = document.createElement('canvas');
            canvas.width = 700;
            canvas.height = 300;
            var ctx = canvas.getContext('2d');

            // ctx.fillStyle = "black";
            // ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.lineJoin = "round";

            var textPosition = 170;

            var text = _s('dialogs.perfectEarnedHeadline');

            ctx.moveTo(0, 100);

            var gradient = ctx.createLinearGradient(0, 50, 0, textPosition);
            gradient.addColorStop(0, "#fffcf3");
            gradient.addColorStop(0.33, "#ffefb0");
            gradient.addColorStop(0.66, "#ffdb4a");
            gradient.addColorStop(1, "#f3c307");

            var strokeGradient = ctx.createLinearGradient(0, 0, 0, textPosition);
            strokeGradient.addColorStop(0, "#ffeb52");
            strokeGradient.addColorStop(0.5, "#ffe478");
            strokeGradient.addColorStop(0.8, "#fea704");
            strokeGradient.addColorStop(1, "#c76c01");

            var blur = 100;

            ctx.font = 'bold ' + Absolute.ScreenMetrics.getResScale() * 65 + 'px Arial';

            ctx.shadowColor = '#ffd429';
            ctx.shadowBlur = blur;

            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = -6;


            ctx.strokeStyle = strokeGradient;
            ctx.lineWidth = 10;
            ctx.strokeText(text, 70, textPosition);

            ctx.shadowColor = 'rgba(153,119,58, 0.8)';
            ctx.shadowBlur = 3;
            ctx.shadowOffsetX = -1;
            ctx.shadowOffsetY = -1;

            ctx.strokeStyle = strokeGradient;
            ctx.lineWidth = 10;
            ctx.strokeText(text, 70, textPosition);

            ctx.shadowColor = 'rgba(243, 68, 0 , 0.9)';
            ctx.shadowBlur = 3;
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;

            ctx.fillStyle = gradient;
            ctx.fillText(text, 70, textPosition);
            ctx.stroke();
            return new PIXI.Sprite(PIXI.Texture.fromCanvas(this.trimCanvas(canvas, ctx)));
        };


        TriPeaksCardAnimator.prototype.BeginShuffleAnimation = function () {
            if (this.WinAnimator != null)
                this.WinAnimator.EndAnimation();
            this.IsShuffling = true;
        };


        TriPeaksCardAnimator.prototype.IsShuffleAnimationRunning = function () {
            return this.IsShuffling;
        };

        /// <summary>
        /// Don't do anything - this game type has no win animation.
        /// </summary>
        TriPeaksCardAnimator.prototype.TriggerWinAnimation = function (endAnimationCallback) {
            this.WinAnimator = null; // Make sure we have no win animation, since this game doesn't have one.
            if (endAnimationCallback != null)
                endAnimationCallback();
        };


        TriPeaksCardAnimator.prototype.ShouldShowEndingPopup = function () {
            if (this.WinAnimator == null)
                return true;
            else
                return this.WinAnimator.ShouldShowEndingPopup();
        };

        TriPeaksCardAnimator.prototype.DoesAnimationBlockInput = function (action) {
            return false; // nothing especially blocks input in this game
        };

        TriPeaksCardAnimator.prototype.DelayNextAnimation = function (delaySeconds) {
            this.NextAnimationDelay = delaySeconds;
        };

        TriPeaksCardAnimator.prototype.OnNextAnimationStart = function (action) {
            this.nextAnimationAction = action;
        };

        TriPeaksCardAnimator.prototype.onHide = function () {
            this.cleanUpParticles();
        };

        TriPeaksCardAnimator.prototype.cleanUpParticles = function () {

            _.each(this.emitters, function (emitter) {
                emitter.destroy();
            });

            this.emitters.length = 0;

            if (this.particleLayer) {
                EngineManagers.UI.stage[0].removeChild(this.particleLayer);
                this.particleLayer = null;
            }

            if (this.cleanUpTimeout !== null) {
                window.clearTimeout(this.cleanUpTimeout);
                this.cleanUpTimeout = null;
            }

        };

        return TriPeaksCardAnimator;

    });

